import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  hasLines: boolean;
  nextStepUrl: string;
}

export default function ToCheckout(props: IProps) {
  const { t } = useTranslation();

  const onClick = useCallback(() => {
    // todo: Dorobit analytics
    window.location.href = props.nextStepUrl;
  }, [props.nextStepUrl]);

  return (
    <div className="flex justify-end mt-8">
      <div>
        <button
          type="button"
          className="btn btn-primary w-64"
          disabled={!props.hasLines}
          onClick={onClick}>
          {t('ToContinue')}
        </button>
      </div>
    </div>
  );
}
